<template>
  <div class="life-story-poster">
    <img
      alt=""
      class="life-story-poster__image"
      decoding="async"
      loading="lazy"
      v-if="image"
      :src="image"
    >
    <button
      class="life-story-poster__open"
      tabindex="-1"
      type="button"
      :aria-label="texts.playLife"
      @click="emit('play')"
    />
    <div class="life-story-poster__text">
      <small>{{ texts.lifeTitle }}</small>
      <span>{{ meta }}</span>
    </div>
    <LifeStoryPill
      class="life-story-poster__pill"
      large
      :text="texts.playLife"
      @click="emit('play')"
    />
  </div>
</template>

<script lang="ts" setup>
  import {
    lifeStoryPoster,
    quickContent,
    slideshowTexts,
  } from "../../composables/useSlideshow";
  import { formatTime, makeFilm } from "../../slideshow/film";
  import { lifeMedia } from "../../slideshow/playlist";
  import LifeStoryPill from "./LifeStoryPill.vue";

  const emit = defineEmits<{ play: [] }>();
  const texts = slideshowTexts();
  const content = quickContent();

  const photos = content
    ? lifeMedia(content).filter((m) => m.type === "image")
    : [];
  const image = lifeStoryPoster(content);
  const duration = content
    ? makeFilm(content, "landscape", false, { kind: "life" }).timeline.duration
    : 0;
  const count = (texts.photoCount || "%d").replace("%d", String(photos.length));
  const meta = `${count} · ${formatTime(duration)}`;
</script>
